var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticClass: "search-contain" },
        [
          _c(
            "el-form",
            {
              ref: "query",
              attrs: { model: _vm.query, inline: true, size: "mini" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "日期:" } },
                [
                  _c("avue-date", {
                    attrs: {
                      type: "datetimerange",
                      format: "yyyy-MM-dd HH:mm:ss",
                      valueFormat: "yyyy-MM-dd HH:mm:ss",
                    },
                    on: { change: _vm.handleChangeTimes },
                    model: {
                      value: _vm.queryTimes,
                      callback: function ($$v) {
                        _vm.queryTimes = $$v
                      },
                      expression: "queryTimes",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "供应商:" } },
                [
                  _c("avue-select", {
                    attrs: {
                      dic: _vm.merchantDic,
                      props: { label: "merchantName", value: "merchantId" },
                      filterable: "",
                      placeholder: "试试搜索:请选择供应商",
                    },
                    model: {
                      value: _vm.query.merchantId,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "merchantId", $$v)
                      },
                      expression: "query.merchantId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "司机信息:" } },
                [
                  _c("avue-select", {
                    attrs: {
                      dic: _vm.driverDic,
                      filterable: "",
                      props: { label: "driverInfo", value: "driverPhone" },
                      placeholder: "试试搜索: 请选择司机信息",
                    },
                    model: {
                      value: _vm.query.driverPhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "driverPhone", $$v)
                      },
                      expression: "query.driverPhone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "订单号:" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入订单号" },
                    model: {
                      value: _vm.query.orderNo,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "orderNo",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.orderNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "车辆信息:" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入车牌号" },
                    model: {
                      value: _vm.query.plateNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "plateNumber", $$v)
                      },
                      expression: "query.plateNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "类型:" } },
                [
                  _c("avue-select", {
                    attrs: {
                      dic: [
                        { label: "接", value: 1 },
                        { label: "送", value: 2 },
                      ],
                      placeholder: "请选择行程类型",
                    },
                    model: {
                      value: _vm.query.tripType,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "tripType", $$v)
                      },
                      expression: "query.tripType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.searchChange },
                    },
                    [_vm._v("筛选")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", icon: "el-icon-delete" },
                      on: { click: _vm.searchReset },
                    },
                    [_vm._v("清空")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "avue-crud",
        {
          ref: "crud",
          attrs: {
            "table-loading": _vm.loading,
            data: _vm.data,
            page: _vm.page,
            option: _vm.option,
          },
          on: {
            "update:page": function ($event) {
              _vm.page = $event
            },
            "current-change": _vm.currentChange,
            "size-change": _vm.sizeChange,
            "refresh-change": _vm.refreshChange,
            "on-load": _vm.onLoad,
          },
          scopedSlots: _vm._u([
            {
              key: "orderNo",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", size: "mini" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleOrderDetails(row)
                        },
                      },
                    },
                    [_vm._v(_vm._s(row.orderNo))]
                  ),
                ]
              },
            },
            {
              key: "orderStatus",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("el-tag", { attrs: { size: "small" } }, [
                    _vm._v(
                      _vm._s(_vm._f("orderStatusFilter")(row.orderStatus))
                    ),
                  ]),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "menuLeft" },
            [
              _c("el-button", { attrs: { type: "primary", size: "small" } }, [
                _vm._v("导出汇总表"),
              ]),
            ],
            1
          ),
        ],
        2
      ),
      _vm.showDialog
        ? _c("order-details-statis", { ref: "orderDetails" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }